/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Socialmedialinksupdated3Inputs */

const en_socialmedialinksupdated3 = /** @type {(inputs: Socialmedialinksupdated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social media links updated`)
};

const de_socialmedialinksupdated3 = /** @type {(inputs: Socialmedialinksupdated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social-Media-Links aktualisiert`)
};

/**
* | output |
* | --- |
* | "Social media links updated" |
*
* @param {Socialmedialinksupdated3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const socialmedialinksupdated3 = /** @type {((inputs?: Socialmedialinksupdated3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Socialmedialinksupdated3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_socialmedialinksupdated3(inputs)
	return de_socialmedialinksupdated3(inputs)
});
export { socialmedialinksupdated3 as "socialMediaLinksUpdated" }